import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import { copyFor, routes } from 'config';
import FlowersGraphic from '/images/settings-page/big-little-flowers.svg';
import { Grid, Page, CenterColumnGridCell, InvisibleHeading } from 'styles';
import { Banner } from 'components/modules/modules.styles';
import { AccountSettingsClosed } from 'pages/settings/components/account-settings';
import { UserSettingsClosed } from 'pages/settings/components/user-settings';
import { Moving } from 'pages/settings/secondary/moving';
import { Contracts } from 'pages/settings/secondary/contracts';
import { PersonalizedContract } from 'pages/settings/secondary/contracts/personalized-contract';
import { PersonalInformation } from 'pages/settings/secondary/personal-information';
import { Name } from 'pages/settings/secondary/personal-information/name';
import { EditLogin } from 'pages/settings/secondary/personal-information/edit-login';
import { SmsPreference } from 'pages/settings/secondary/personal-information/sms-preference';
import { HeroGridCell, StyledSVG } from 'pages/settings/settings.style';
import { CheckLmiEligibility } from '../secondary/lmi-eligibility';

const routeTemplates = routes();
const getCopy = copyFor('settings');

const Settings = () => (
  <Page small={{ padding: '0px' }}>
    <Grid width="100%" gap="24px">
      <HeroGridCell>
        <Banner
          flex
          justifyContent="center"
          color="primaryInverse"
          opacity="medium"
        >
          <StyledSVG width="100.62px" src={FlowersGraphic} aria-hidden="true" />
        </Banner>
      </HeroGridCell>
      <CenterColumnGridCell>
        <InvisibleHeading tag="h1" textStyle="heading700">
          {getCopy('title')}
        </InvisibleHeading>
        <AccountSettingsClosed />
        <UserSettingsClosed />
      </CenterColumnGridCell>
    </Grid>
  </Page>
);

export const Closed = () => {
  return (
    <Switch>
      <Route exact path={routeTemplates.contracts} component={Contracts} />
      <Route
        path={routeTemplates.personalizedContract}
        component={PersonalizedContract}
      />
      <Route path={routeTemplates.name} component={Name} />
      <Route path={routeTemplates.editLogin} component={EditLogin} />
      <Route path={routeTemplates.smsPreference} component={SmsPreference} />
      <Route
        path={routeTemplates.checkLmiEligibility}
        component={CheckLmiEligibility}
      />
      <Route
        path={routeTemplates.personalInformation}
        component={PersonalInformation}
      />
      <Route path={routeTemplates.moving} component={Moving} />
      <Route path={routeTemplates.settings} component={Settings} />
      <Redirect to={routeTemplates.settings} />
    </Switch>
  );
};
